export const FETCH_STAFF_USER_SEGMENTS_REQUEST =
  "FETCH_STAFF_USER_SEGMENTS_REQUEST";
export const FETCH_STAFF_USER_SEGMENTS_SUCCESS =
  "FETCH_STAFF_USER_SEGMENTS_SUCCESS";
export const FETCH_STAFF_USER_SEGMENTS_FAILURE =
  "FETCH_STAFF_USER_SEGMENTS_FAILURE";



// WEBPACK FOOTER //
// ./src/actions/staffUserSegments/types.js